import { Product } from "./app-product";

export class ShoppingCartItem{
    $key:string;
    title:string;
    price:number;
    imageUrl:string;
    quantity:number;
    constructor(init?:Partial<ShoppingCartItem>){
        Object.assign(this,init)
     }

    get totalPrice(){
        return this.price*this.quantity
    }
}


// WEBPACK FOOTER //
// G:/MyProjects/Angular/oshop/src/app/models/shopping-cart-item.ts